import type { DateTime } from 'luxon'

/** Day-of-week + date badge on the hero card (v1). */
export const AssignmentDateBadge = ({
  datetime,
}: {
  datetime: DateTime | undefined
}) => (
  <div className='assignment-card__date-badge'>
    <span className='assignment-card__day-of-week'>
      {datetime?.toFormat('ccc').toUpperCase() ?? '—'}
    </span>
    <span className='assignment-card__date-text'>
      {datetime?.toFormat('LLL dd').toUpperCase() ?? ''}
    </span>
  </div>
)
